import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as InstantLeaseApi from '../../api/instant-lease-api';
import {
  FeedbackAnswer,
  FeedbackBrowserData,
  UserExperience,
} from '../../types/instant-lease-api';
import { AuthState } from '../auth/types';

type FeedbackForm = {
  isOpened: boolean;
};

export type Feedback = {
  feedbackForm: FeedbackForm;
  experienceForm: FeedbackForm;
  experience: UserExperience.UserExperience | undefined;
};

export const initialState: Feedback = {
  feedbackForm: { isOpened: false },
  experienceForm: { isOpened: false },
  experience: undefined,
};

export const saveFeedback = createAsyncThunk(
  'saveFeedback',
  async ({
    accessToken,
    answer_list,
    browser_data,
  }: {
    accessToken: string;
    answer_list: FeedbackAnswer[];
    browser_data: FeedbackBrowserData;
  }) =>
    InstantLeaseApi.saveFeedbackSurveyResponses(accessToken, {
      answer_list,
      browser_data,
    }),
);

export const updateUserExperience = createAsyncThunk(
  'updateUserExperience',
  async ({
    accessToken,
    leaseApplicationId,
    experience,
  }: {
    accessToken: string;
    leaseApplicationId: string;
    experience: UserExperience.Experience;
  }) =>
    InstantLeaseApi.updateUserExperience(
      accessToken,
      leaseApplicationId,
      experience,
    ),
);

export const fetchUserExperiences = createAsyncThunk(
  'fetchUserExperiences',
  async ({ auth }: { auth: AuthState }) =>
    InstantLeaseApi.fetchUserExperiences(auth),
);

// createSlice uses immer under the hood
export const feedbackSlice = createSlice({
  name: 'feedback',
  initialState,
  reducers: {
    openFeedbackForm(state) {
      state.feedbackForm.isOpened = true;
    },
    closeFeedbackForm(state) {
      state.feedbackForm.isOpened = false;
    },
    openExperienceForm(state) {
      if (!state.experience) {
        state.experienceForm.isOpened = true;
      }
    },
    closeExperienceForm(state) {
      state.experienceForm.isOpened = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateUserExperience.fulfilled, (state, action) => {
      state.experience = action.payload;
    });
    builder.addCase(fetchUserExperiences.fulfilled, (state, action) => {
      state.experience = action.payload.length ? action.payload[0] : undefined;
    });
  },
});

export const {
  openFeedbackForm,
  closeFeedbackForm,
  openExperienceForm,
  closeExperienceForm,
} = feedbackSlice.actions;

export default feedbackSlice.reducer;
